<template lang="pug">
  ods-main-header(
    headerLogoText="cities<span class='landscape'>landscape</span>"
    logoUrl="/"
    breadcrumbSeparator=">"
    userMenuImage="alberto.jpg"
    :showBreadcrumbs="true"
    :showNotifications="true"
    :notifications="notifications"
    :showActionsMenu="false"
    :showUserMenu="true")
    template(slot="userAvatar").ods-ml-2
      img(src="@/assets/images/header/avatar.svg")
    template(slot="user")
      user-menu
    template(slot="custom")
      header-custom-content
</template>

<script>
import notificationsDemo from '../../../static/notificationsDemo.json'
import HeaderActions from '@/components/header/HeaderActions'
import UserMenu from '@/components/header/UserMenu'
import HeaderCustomContent from '@/components/header/HeaderCustomContent'
import * as _ from 'lodash'

export default {
  name: 'HeaderContent',
  components: {
    HeaderActions,
    UserMenu,
    HeaderCustomContent
  },
  computed: {
    notifications () {
      return _.orderBy(notificationsDemo, ['status', 'date'], ['asc', 'desc'])
    },
    env () {
      return process.env.HEADER_ENVIRONMENT
    },
    user () {
      return 'Pedro Páramo'
    }
  }
}
</script>
<style lang="scss">
.ods-main-header{
  &__logo{
    .logo_text{
      h2{
        display: flex;
        flex-direction: column;
        line-height: 18px;
        span{
          font-size: 12px;
        }
      }
    }
  }

  .ods-breadcrumb{
    &__item{
      &:first-child{
        .ods-breadcrumb__inner{
          font-weight: 500;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/HeaderContent.vue